import { evolutionPathPair } from "../../evolutions/evolutionPath";
import axios from "../api";
/**
 * The chains the solver recommends from the current chain. Same body as
 * `/one-steps`, plus the evolutions a chain must go through.
 */
export const getEvolutionChainRecommendations = async ({ resourceId, currentChain, currentPathwayChain, assetId, evoPathId, playerRoleIds, includedEvolutions, mustIncludeEvolutions, filters = {}, }) => {
    const body = {};
    if (currentChain.length > 0) {
        const { evolutionPath, pathwayPath } = evolutionPathPair(currentChain, currentPathwayChain);
        body.evoPath = evolutionPath;
        body.pathwayPath = pathwayPath;
    }
    if (evoPathId)
        body.evoPathId = evoPathId;
    if (playerRoleIds?.length)
        body.playerRoleIds = playerRoleIds;
    if (assetId)
        body.assetId = assetId;
    if (includedEvolutions?.length)
        body.includedEvos = includedEvolutions;
    if (mustIncludeEvolutions?.length) {
        body.mustIncludeEvos = mustIncludeEvolutions;
    }
    const res = await axios.post(`/players/${resourceId}/next-evo-steps/chains?v=2`, { ...body, filters: filters ?? {}, v: 2 });
    return res.data;
};
//# sourceMappingURL=getEvolutionChainRecommendations.js.map